module.exports = __webpack_public_path__ + "img/proList2_27_11.bd7d8bda.jpg";